import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { mediaUrl } from "@/lib/api";

export default function UserIdentity({ user, size = 44, showStatus = true, onClick }) {
  const initial = (user?.username || "?").charAt(0).toUpperCase();
  const role = user?.profile_role;
  const usernameColor = user?.owned_perks?.includes?.("username_color") ? ({ pink: "#f472b6", purple: "#c084fc", blue: "#60a5fa", green: "#34d399", orange: "#fb923c" }[user?.username_color] || undefined) : undefined;
  const roleStyles = {
    vip: "bg-amber-50 text-amber-600 dark:bg-amber-950/30 dark:text-amber-300",
    elite: "bg-cyan-50 text-cyan-600 dark:bg-cyan-950/30 dark:text-cyan-300",
    legend: "bg-orange-50 text-orange-600 dark:bg-orange-950/30 dark:text-orange-300",
  };
  return (
    <div onClick={onClick} role={onClick ? "button" : undefined} tabIndex={onClick ? 0 : undefined} onKeyDown={(e) => { if (onClick && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); onClick(); } }} className={`flex min-w-0 items-center gap-3 ${onClick ? "cursor-pointer rounded-xl px-1 py-1 transition hover:bg-slate-50 dark:hover:bg-slate-800" : ""}`}>
      <div className={`relative z-10 shrink-0 ${user?.owned_perks?.includes?.("profile_frame") ? "rounded-full ring-4 ring-pink-300 ring-offset-2" : ""}`}>
        <Avatar style={{ width: size, height: size }}>
          <AvatarImage src={mediaUrl(user?.avatar_url)} alt={user?.username} />
          <AvatarFallback className="bg-pink-500 font-bold text-white">{initial}</AvatarFallback>
        </Avatar>
        {showStatus && user?.is_online && (
          <span className="pointer-events-none absolute right-0 top-0 z-30 h-3.5 w-3.5 rounded-full border-2 border-white bg-green-500 dark:border-slate-900" />
        )}
      </div>
      <div className="min-w-0">
        <div className="flex min-w-0 items-center gap-1.5"><p className="truncate font-heading font-bold" data-yaprio-username-color={usernameColor || undefined} style={usernameColor ? { color: usernameColor, "--yaprio-username-color": usernameColor } : { color: "hsl(var(--foreground))" }}>@{user?.username}</p>{role && <span className={`shrink-0 rounded-full px-1.5 py-0.5 text-[9px] font-black ${roleStyles[role] || "bg-pink-50 text-pink-500"}`}>{role.toUpperCase()}</span>}{user?.owned_perks?.includes?.("chat_badge") && <span className="shrink-0 text-[10px]" title="Chat Badge">💬</span>}</div>
        <p className="truncate text-sm text-slate-400">
          {user?.status_message || (user?.is_online ? "Online" : "Offline")}
        </p>
      </div>
    </div>
  );
}
